import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EstateAgentProfile = _resolveComponent("EstateAgentProfile")!
  const _component_UserBasicProfile = _resolveComponent("UserBasicProfile")!

  return (_ctx.user.isEstateAgent)
    ? (_openBlock(), _createBlock(_component_EstateAgentProfile, { key: 0 }))
    : (_openBlock(), _createBlock(_component_UserBasicProfile, { key: 1 }))
}